import { z } from 'zod';

export const IntegrationType = z.enum([
  'ShareFile',
  'Greenhouse',
  'Workday',
  'HTTP',
  'Merge',
  'Postgres',
  'ADP',
  'Snowflake',
  'Peregrine',
  'SqlServer',
]);

export type IntegrationType = z.infer<typeof IntegrationType>;

export const IntegrationTypes = Object.values(IntegrationType.Values);
